import React, { useState, useEffect } from "react";
import Button from "components/Button";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "components/DatePicker";
import DropDown from "components/DropDown"
import * as moment from 'moment';
import styled from "styled-components";
import { BIDFORMAT } from 'utils/dateOfBirthValidation';
import { Container, SelectWrapper } from "styles/components/FilterModal";
import { getLoggedInUserCountry } from "helpers";
import { useText } from "locales/useGetText";

const FilterModal = ({ InnerClassName, className, callBackFun, currentTab, ...props }) => {
  const locale = useText("manageOrder");
  const fromDate = moment().subtract(20, 'days');
  const toDate = moment().add(90, 'days');
  const [requestedFromDate, setRequestedFromDate] = useState(fromDate.format('MM/DD/YYYY'));
  const [requestedToDate, setRequestedToDate] = useState(toDate.format('MM/DD/YYYY'));
  const userCountry = getLoggedInUserCountry();
  const isUSA = userCountry?.toUpperCase() === "USA";

  let statusArr;
  if (currentTab === 0) {
    statusArr = [{ label: locale("statusRequested"), value: "REQUESTED" }];
  }
  if (currentTab === 1) {
    statusArr = [
      { label: locale("all"), value: "ASSIGNED" },
      { label: locale("statusAssigned"), value: "ASSIGN" },
      { label: locale("statusShipped"), value: "SHIPPED" },
      // { label: "Requested Order", value: "REQUESTED" },
      ...(isUSA ? [{ label: locale("rescheduleRequest"), value: "RESCHEDULED" }] : []),
      { label: locale("hold"), value: "HOLD" },
      // { label: "Scheduled", value: "SCHEDULED" },
      // { label: "Delivered", value: "DELIVERED" },
      // { label: "Complete", value: "COMPLETE" },
      // { label: "Canceled", value: "CANCELLED" },
      // { label: "Claim", value: "CLAIM" },  
    ];
  }
  if (currentTab === 2) {
    statusArr = [
      { label: locale("all"), value: "DELIVER_PICKUP" },
      { label: locale("statusDelivered"), value: "DELIVERED" },
      { label: locale("pickedUp"), value: "PICKEDUP" },
    ];
  }
  if (currentTab === 3) {
    statusArr = [{ label: locale("statusCompleted"), value: "COMPLETE" }];
  }
  if (currentTab === 4) {
    statusArr = [{ label: locale("statusCancelled"), value: "CANCELLED" }];
  }
  if (currentTab === 5) {
    statusArr = [{ label: locale("statusClaimed"), value: "CLAIM" }];
  }
  if (currentTab === 6) {
    statusArr = [
      { label: locale("all"), value: "ALL" },
      // { label: "Assign", value: "ASSIGN" },
      { label: locale("statusAssigned"), value: "ASSIGN" },
      { label: locale("statusShipped"), value: "SHIPPED" },
      // { label: "Requested Order", value: "REQUESTED" },
      ...(isUSA ? [{ label: locale("rescheduleRequest"), value: "RESCHEDULED" }] : []),
      { label: locale("hold"), value: "HOLD" },
      // { label: "Scheduled", value: "SCHEDULED" },
      { label: locale("statusDelivered"), value: "DELIVERED" },
      { label: locale("pickedUp"), value: "PICKEDUP" },
      { label: locale("statusCompleted"), value: "COMPLETE" },
      { label: locale("statusCancelled"), value: "CANCELLED" },
      { label: locale("statusClaimed"), value: "CLAIM" },
    ];
  }
  const [orderStatus, setOrderStatus] = useState(statusArr[0].value)

  useEffect(() => {
    setOrderStatus(statusArr[0].value)
    // setRequestedFromDate(
    //   fromDate.toISOString().substr(0, 10)
    // );
    // setRequestedToDate(
    //   toDate.toISOString().substr(0, 10)
    // );
  }, [statusArr[0].value], fromDate, toDate);

  return (
    <Modal
      isOpen={props?.isOpen}
      toggle={props?.toggle}
      backdrop={"static"}
      centered={true}
      size="lg"
      className={className}
    >
      <Container className={InnerClassName}>
        <ModalBody>
          <div>
            <h3 className="modal-title">{props?.title}</h3>
          </div>
          <div className="ModalContentMsg">
            <DropDownWrapper>
              <div className="dropDown">
                <label>{locale("orderStatus")}</label>
                {(currentTab === 1 || currentTab === 2 || currentTab === 6) ? (
                  <DropDown
                    name="bidStatus"
                    data={statusArr}
                    placeholder=""
                    searchDropDown={orderStatus}
                    searchable={true}
                    onChangeHandler={(val) => {
                      setOrderStatus(val)
                    }}
                  />
                ) : (
                  <div>
                    <span
                      style={{
                        "margin-left": "10px",
                        "font-size": "1rem",
                      }}
                    >
                      {statusArr[0].label}
                    </span>
                  </div>
                )}
              </div>
            </DropDownWrapper>

            <SelectWrapper>
              <label>{locale("requestedDate")}</label>
              <div style={{ padding: '7px' }}>
                <DatePicker name="fromDate" maxDOBirth={requestedToDate} value={requestedFromDate} callBackFun={(date) => {
                  setRequestedFromDate(moment(date).format('MM/DD/YYYY'));
                }} />

                <p style={{ 'margin-top': '5px' }}>{locale("to")}</p>
                <DatePicker name="toDate" minDOBirth={requestedFromDate} value={requestedToDate} callBackFun={(date) => {
                  setRequestedToDate(moment(date).format('MM/DD/YYYY'));
                }} />
              </div>
            </SelectWrapper>
          </div>
          <ModalFooter className='modal-footer'>
            <Button
              type="app-green-button filter-cancel-button"
              handleClick={() => {
                props?.toggle(!props?.isOpen);
              }}
            >
              {locale("cancel")}
            </Button>
            <Button
              className="AlertBtn"
              type="app-green-button AlertBtn"

              handleClick={() => {
                props?.toggle(!props?.isOpen);             
                callBackFun(requestedFromDate, requestedToDate, orderStatus)
              }}
            >
              {locale("applyFilters")}
            </Button>
          </ModalFooter>
          {/* <div style={{ display: 'flex' }}>
            <button
              // className="filter-cancel-buttton"
              // type="app-green-button AlertBtn"
              onClick={() => {
                props?.toggle(!props?.isOpen);
              }}
            >
              Cancel
            </button>
            <Button
              type="app-green-button submitBtn AlertBtn"
              handleClick={() => {
                props?.toggle(!props?.isOpen);
                callBackFun(requestedFromDate, requestedToDate)
              }}
            >
              Apply Filters
            </Button>
          </div> */}
        </ModalBody>
      </Container>
    </Modal>
  );
};

export default FilterModal;

const DropDownWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  .dropDown {
    div {
      p {
        margin: 12px;
      }
    }
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 18px;
  }
`;
